(function () {
  'use strict';

  const KEYWORD_RULES = [
    { label: 'Arbeitsspeicher',  pattern: /\b(ddr[345]?|lpddr\d?|sdram)\b|\d+\s*gb\s*(ram|arbeitsspeicher)/i },
    { label: 'Prozessor',        pattern: /intel\s+core|amd\s+ryzen|ryzen|celeron|pentium|xeon|\b(i[3579][-\s]\d{4}|core\s+i[3579])\b|ghz|quad.?core|dual.?core/i },
    { label: 'Festplatte',       pattern: /\b(ssd|hdd|nvme|emmc|m\.?2|sata)\b|\d+\s*(gb|tb)\s*(ssd|hdd|speicher|festplatte)/i },
    { label: 'Display',          pattern: /\b(zoll|ips|tn|oled|fhd|full.?hd|uhd|4k|1920|1366|2560|retina|nits|hz|touch(screen)?)\b|display|bildschirm/i },
    { label: 'Grafik',           pattern: /\b(nvidia|geforce|radeon|intel\s+uhd|intel\s+iris|quadro|amd\s+graphics|gtx|rtx|mx\d+)\b/i },
    { label: 'Betriebssystem',   pattern: /\b(windows\s*1[01]|windows\s*[78]|macos|mac\s*os|linux|ubuntu|chrome\s*os)\b/i },
    { label: 'Konnektivität',    pattern: /\b(wlan|wi.?fi|wireless|bluetooth|ethernet|lan|rj.?45|nfc|4g|lte|5g)\b/i },
    { label: 'Anschlüsse',       pattern: /\b(usb[\s-]?[0-9]?\.?[0-9]?|usb.?c|thunderbolt|hdmi|displayport|vga|sd.?card|klinke|\baudio\b|audio.?port|audio.?buchse|dock)\b/i },
    { label: 'Kamera',           pattern: /\b(webcam|kamera|hd.?cam|ir.?kamera|infrarot.?kamera|gesichtserkennung|mikrofon|microphone)\b/i },
    { label: 'Tastatur',         pattern: /\b(tastaturbeleuchtung|backlit|hintergrundbeleuchtung|beleuchtet|tastatur|keyboard)\b/i },
    { label: 'Akku',             pattern: /\b(akku|batterie|\d+\s*wh|\d+\s*mah|lithium|laufzeit)\b/i },
    { label: 'Gewicht',          pattern: /\b(\d[\d,.]*\s*kg|\d[\d,.]*\s*g\b|gewicht)\b/i },
    { label: 'Maße',             pattern: /\b(\d+[\s,x×*]\d+[\s,x×*]\d+\s*mm|abmessung|maße|dimension)/i },
    { label: 'Formfaktor',       pattern: /\b(convertible|2.in.1|ultrabook|tablet.?modus|gaming.?laptop|detachable)\b/i },
    { label: 'Sicherheit',       pattern: /\b(fingerabdruck|tpm|smartcard|fingerprint|windows\s*hello|kameraabdeckung|sichtschutz|privacy)\b/i },
    { label: 'Zustand',          pattern: /\b(generalüberholt|refurbished|sehr\s*gut|gut\s*erhalten|gebraucht|neuwertig|grade\s*[abc])\b/i },
  ];

  // Section headings that should be captured verbatim (not keyword-matched)
  const NAMED_SECTIONS = [
    { label: 'Lieferumfang', pattern: /lieferumfang/i },
    { label: 'Besonderheiten', pattern: /besonderheit|highlight|feature/i },
    { label: 'Garantie', pattern: /garantie|gewährleistung/i },
  ];

  const META_LABELS = {
    color_pattern:                'Farbe',
    connectivity_technology:      'Verbindungstyp',
    item_condition:               'Äußerer Zustand',
    display_resolution:           'Bildschirmauflösung',
    gpu_type:                     'Grafikkartentyp',
    keyboard_type:                'Tastaturtyp',
    memory_technology:            'Speichertechnologie',
    compatible_operating_systems: 'Betriebssystem',
    optical_drive_type:           'Typ des optischen Laufwerks',
    processor_family:             'Prozessorfamilie',
    storage_type:                 'Unterstützte Speicherarten',
    computer_type:                'Computerform',
  };

  function categorize(text) {
    for (const rule of KEYWORD_RULES) {
      if (rule.pattern.test(text)) return rule.label;
    }
    return null;
  }

  function namedSection(text) {
    for (const ns of NAMED_SECTIONS) {
      if (ns.pattern.test(text)) return ns.label;
    }
    return null;
  }

  function isBlockIntro(el) {
    const tag = el.tagName;
    if (/^H[1-6]$/.test(tag)) return true;
    if (tag === 'P' || tag === 'DIV') {
      // Bold-only paragraph acts as heading
      const text = el.textContent.trim();
      const inner = el.innerHTML.trim();
      if ((inner.startsWith('<strong>') || inner.startsWith('<b>')) && text.length < 80) return true;
    }
    return false;
  }

  function parseDescription(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const rows = {};        // label → value (ordered via insertion)
    const grouped = {};     // keyword-category → [items]
    const misc = [];        // uncategorized loose items

    // 1. Tables
    doc.querySelectorAll('table tr').forEach(tr => {
      const cells = tr.querySelectorAll('td, th');
      if (cells.length >= 2) {
        const label = cells[0].textContent.trim().replace(/:$/, '');
        const value = cells[1].textContent.trim();
        if (label && value) rows[label] = value;
      }
    });

    // 2. Definition lists
    doc.querySelectorAll('dt').forEach(dt => {
      const dd = dt.nextElementSibling;
      if (dd && dd.tagName === 'DD') {
        const label = dt.textContent.trim().replace(/:$/, '');
        const value = dd.textContent.trim();
        if (label && value) rows[label] = value;
      }
    });

    // 3. Walk top-level block elements to detect section headings + following lists
    const body = doc.body;
    let currentSection = null;  // named section currently open
    const sectionItems = {};    // named section label → [items]

    Array.from(body.children).forEach(el => {
      if (isBlockIntro(el)) {
        const text = el.textContent.trim().replace(/:$/, '');
        const ns = namedSection(text);
        currentSection = ns || null;
        return;
      }

      if (el.tagName === 'UL' || el.tagName === 'OL') {
        const items = Array.from(el.querySelectorAll('li'))
          .map(li => li.textContent.trim())
          .filter(Boolean);

        if (currentSection) {
          // Named section — collect all items verbatim
          if (!sectionItems[currentSection]) sectionItems[currentSection] = [];
          sectionItems[currentSection].push(...items);
        } else {
          // Keyword-categorize each item
          items.forEach(text => {
            const colonIdx = text.indexOf(':');
            if (colonIdx > 0 && colonIdx < 50) {
              const lbl = text.slice(0, colonIdx).trim();
              const val = text.slice(colonIdx + 1).trim();
              if (lbl && val) { rows[lbl] = val; return; }
            }
            // Split comma-separated parts that span multiple categories
            const parts = text.split(/,\s+/);
            if (parts.length > 1) {
              const cats = parts.map(p => categorize(p));
              const uniqueCats = new Set(cats.filter(Boolean));
              if (uniqueCats.size > 1) {
                parts.forEach((p, i) => {
                  const c = cats[i];
                  const t = p.trim();
                  if (c) { if (!grouped[c]) grouped[c] = []; grouped[c].push(t); }
                  else { misc.push(t); }
                });
                return;
              }
            }
            const cat = categorize(text);
            if (cat) {
              if (!grouped[cat]) grouped[cat] = [];
              grouped[cat].push(text);
            } else {
              misc.push(text);
            }
          });
        }
        currentSection = null;  // section ends after its list
        return;
      }

      // Paragraph with "Label: Value"
      if (el.tagName === 'P') {
        const text = el.textContent.trim();
        const colonIdx = text.indexOf(':');
        if (colonIdx > 0 && colonIdx < 50 && !text.includes('\n')) {
          const lbl = text.slice(0, colonIdx).trim();
          const val = text.slice(colonIdx + 1).trim();
          if (lbl && val) { rows[lbl] = val; return; }
        }
      }
    });

    // Merge keyword groups first (spec rows)
    Object.entries(grouped).forEach(([cat, items]) => {
      if (!rows[cat]) rows[cat] = items.join(', ');
    });

    // Sonstiges — truly uncategorized items
    if (misc.length) {
      rows['Sonstiges'] = misc.join(', ');
    }

    // Named sections (Lieferumfang etc.) always last
    Object.entries(sectionItems).forEach(([label, items]) => {
      if (!rows[label]) rows[label] = items.join(', ');
    });

    return rows;
  }

  function parseMetafields(meta) {
    if (!meta || typeof meta !== 'object') return {};
    const rows = {};
    Object.entries(META_LABELS).forEach(([key, label]) => {
      const val = meta[key];
      if (val == null || val === '' || val === false) return;
      let display = val;
      if (Array.isArray(val)) display = val.join(', ');
      else if (typeof val === 'object' && val.value !== undefined) display = val.value;
      rows[label] = String(display).trim();
    });
    return rows;
  }

  function makeRow(label, value) {
    const row = document.createElement('div');
    row.className = 'specs-row specs-row--auto';
    row.innerHTML =
      '<div class="specs-label">' + escapeHtml(label) + '</div>' +
      '<div class="specs-value">' + escapeHtml(value) + '</div>';
    return row;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function applyToggle(table, toggleWrapper, initialRows) {
    const rows = table.querySelectorAll('.specs-row');
    if (rows.length <= initialRows) {
      toggleWrapper.style.display = 'none';
      return;
    }
    rows.forEach((row, i) => {
      if (i >= initialRows) row.classList.add('specs-row--hidden');
    });
    toggleWrapper.style.display = '';

    const btn = toggleWrapper.querySelector('.specs-toggle');
    btn.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      rows.forEach((row, i) => {
        if (i >= initialRows) row.classList.toggle('specs-row--hidden', expanded);
      });
      this.setAttribute('aria-expanded', String(!expanded));
    });
  }

  function initSection(sectionId) {
    const cfg = window.__npoSpecs && window.__npoSpecs[sectionId];
    if (!cfg) return;

    const table = document.getElementById('specs-table-' + sectionId);
    const toggleWrapper = document.getElementById('specs-toggle-' + sectionId);
    if (!table) return;

    const existingLabels = new Set();
    table.querySelectorAll('.specs-label').forEach(el => {
      existingLabels.add(el.textContent.trim().toLowerCase());
    });

    function addRow(label, value) {
      if (existingLabels.has(label.toLowerCase())) return;
      existingLabels.add(label.toLowerCase());
      table.appendChild(makeRow(label, value));
    }

    if (cfg.description) {
      const descRows = parseDescription(cfg.description);
      Object.entries(descRows).forEach(([label, value]) => addRow(label, value));
    }

    if (cfg.meta) {
      const metaRows = parseMetafields(cfg.meta);
      Object.entries(metaRows).forEach(([label, value]) => addRow(label, value));
    }

    if (toggleWrapper) {
      applyToggle(table, toggleWrapper, cfg.initialRows || 6);
    }
  }

  function init() {
    if (!window.__npoSpecs) return;
    Object.keys(window.__npoSpecs).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
